@use '@/theme/viewerDefs' as *;

.timer {
  white-space: nowrap;

  line-height: 0.9;
  letter-spacing: 0.1em;
  font-weight: 600;
  font-size: 3.5rem;

  &[data-phase='default'] {
    color: $timer-color;
  }

  &[data-phase='warning'] {
    color: $warning-orange;
  }

  &[data-phase='danger'] {
    color: $error-red;
  }

  &[data-phase='overtime'] {
    color: $playback-negative;
  }

  &[data-phase='pending'] {
    color: $ontime-roll;
  }

  &[data-phase='none'] {
    color: $muted-gray;
  }
}
